/// <reference path="../../../../../../node_modules/monaco-editor/monaco.d.ts" />
import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { PfPlanFile } from "src/app/generated-models/PfPlanFile";

export interface PlanEditorModalOptions {
  model: PfPlanFile;
  save: (model: PfPlanFile) => Promise<any>;
  isReadonly: boolean;
  schema: string;
}

export interface PlanJsonSchema {
  FullSchema: string;
  MergeSchema: string;
}

@Component({
  standalone: false,
  templateUrl: "./pf-plan-editor-modal.component.html",
  styleUrls: ["../../../../styles.scss", "../../pf.scss"],
})
export class PfPlanEditorModalComponent implements OnInit {
  @Input() options: PlanEditorModalOptions;
  editor: monaco.editor.IStandaloneCodeEditor;
  pfPlanFile: PfPlanFile;

  constructor(public activeModal: NgbActiveModal, private notificationService: ToastrService) {}

  async ngOnInit() {
    this.pfPlanFile = this.options.model;
  }

  onEditorReady(editor: monaco.editor.IStandaloneCodeEditor) {
    this.editor = editor;
    this.editor.setValue(this.pfPlanFile.Content);
    monaco.editor.setModelLanguage(this.editor.getModel(), this.pfPlanFile.Format);
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      validate: true,
      allowComments: true,
      schemas: [
        {
          uri: "http://lionrock/pf-plan-schema.json",
          fileMatch: ["*"],
          schema: JSON.parse(this.options.schema),
        },
      ],
    });

    // delay 1sec for formatting the content
    setTimeout(() => {
      this.editor
        .getAction("editor.action.formatDocument")
        .run()
        .then(() => {
          this.editor.updateOptions({ readOnly: this.options.isReadonly });
        });
    }, 1000);
  }

  async submit() {
    try {
      this.pfPlanFile.Content = this.editor.getValue();
      await this.options.save(this.pfPlanFile);
    } catch (e) {
      this.notificationService.error(e);
    }
  }
}
